import React, {useContext, useEffect} from 'react'
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";
import {getStockById} from "../../../../../services/serviceStock";
import {AutoComplete, Form} from "antd";

const {Option} = AutoComplete


const IngredientsStock = ({stockList, row, responseIndex}) => {
    const [form] = Form.useForm()
    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId

    useEffect(() => {
        if (row.hasOwnProperty('stock')) {
            form.setFieldsValue({
                ingredientStock:  `${row.stock.code} - ${row.stock.name}`
            })
        }
    })

    const handleStockChange = (value, option) => {
        if (option.key) {
            getStockById(option.key)
                .then(({data}) => {
                    let mockRows = Object.assign({}, recipeById)
                    mockRows.billOfMaterials[responseIndex] = {
                        ...mockRows.billOfMaterials[responseIndex],
                        unitPrice: data.price,
                        stock: data
                    }
                    setRecipeById(mockRows)
                })
        }
    }

    return (
        <React.Fragment>
            <div className={'recipe-stock'}>
                <Form
                    form={form}
                >
                    <Form.Item
                        name={'ingredientStock'}
                        wrapperCol={{span: 24}}>
                        <AutoComplete
                            className={'recipe-stock-select'}
                            onChange={handleStockChange}
                            filterOption={(inputValue, option) =>
                                option.value.toLocaleLowerCase().indexOf(inputValue.toLocaleLowerCase()) !== -1
                            }
                        >
                            {stockList.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                </Form>
            </div>
        </React.Fragment>
    )
}
export default IngredientsStock